import NiceModal, { type NiceModalHandler, type NiceModalStore, useModal } from '@ebay/nice-modal-react'
import { type OverScreenIds } from './types'
import { useContext, type JSX } from 'react'
import type React from 'react'

declare type NiceModalArgs<T> = T extends keyof JSX.IntrinsicElements | React.JSXElementConstructor<any>
  ? Omit<React.ComponentProps<T>, 'id'>
  : Record<string, unknown>

export const useOverscreenContext = (): NiceModalStore => {
  return useContext(NiceModal.NiceModalContext)
}

const OverScreen = {
  // ComponentType so next/dynamic() results can be registered (DynamicComponentType is not FC).
  register: <T extends React.ComponentType<any>>(
    id: OverScreenIds,
    component: T,
    props?: Partial<NiceModalArgs<T>>
  ): void => {
    NiceModal.register(id, component as React.FC<any>, props)
  },
  show: async <T>(id: OverScreenIds, props?: T): Promise<T> => {
    return await NiceModal.show(id, props)
  },
  remove: (id: OverScreenIds): void => {
    NiceModal.remove(id)
  },
  create: NiceModal.create,
  Provider: NiceModal.Provider
}

interface OverScreenHandler extends NiceModalHandler {}

const useOverScreen = (modal: OverScreenIds, args?: Record<string, unknown>): Omit<OverScreenHandler, 'hide'> => {
  return useModal(modal, args)
}

export default OverScreen

export { OverScreen, useOverScreen }
